import { Bot, Sparkles } from 'lucide-react';

interface ThinkingIndicatorProps {
  label?: string;
  avatarUrl?: string;
  onAvatarError?: () => void;
  avatarFallback?: boolean;
}

export function ThinkingIndicator({
  label = 'Thinking',
  avatarUrl,
  onAvatarError,
  avatarFallback = false,
}: ThinkingIndicatorProps) {
  return (
    <div className="flex gap-3 mb-6 animate-fade-in">
      <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-gradient-to-br from-[#1875FF] to-[#05E0D1] shadow-md overflow-hidden">
        {avatarUrl && !avatarFallback ? (
          <img
            src={avatarUrl}
            alt="Sales Coach"
            className="w-full h-full object-cover"
            onError={onAvatarError}
            loading="eager"
          />
        ) : (
          <Bot className="w-5 h-5 text-white" />
        )}
      </div>
      <div className="flex-1 max-w-3xl">
        <div className="rounded-2xl px-5 py-4 bg-gradient-to-br from-white to-[#1875FF]/5 border-2 border-[#1875FF]/20 shadow-lg">
          <div className="flex items-center gap-2.5">
            <div className="relative flex items-center justify-center w-5 h-5">
              <div className="absolute inset-0 bg-gradient-to-br from-[#1875FF]/20 to-[#05E0D1]/20 rounded-full animate-ping" style={{ animationDuration: '2s' }} />
              <Sparkles className="w-4 h-4 text-[#1875FF] relative z-10 animate-pulse" style={{ animationDuration: '1.5s' }} />
            </div>
            <span className="text-sm font-medium text-gray-500 tracking-wide">
              {label}
            </span>
            <div className="flex items-center gap-1 ml-0.5">
              <span
                className="block w-1.5 h-1.5 rounded-full bg-[#1875FF]/60 animate-bounce"
                style={{ animationDuration: '1.2s', animationDelay: '0ms' }}
              />
              <span
                className="block w-1.5 h-1.5 rounded-full bg-[#1875FF]/60 animate-bounce"
                style={{ animationDuration: '1.2s', animationDelay: '200ms' }}
              />
              <span
                className="block w-1.5 h-1.5 rounded-full bg-[#1875FF]/60 animate-bounce"
                style={{ animationDuration: '1.2s', animationDelay: '400ms' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
